<template>
    <section class="section section-lg pt-lg-0 mt--200">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-12">
                    <div class="row row-grid">
                        <div class="col-lg-3">
                            <card
                                class="border-0"
                                hover
                                shadow
                                body-classes="py-5"
                            >
                                <div class="text-center pb-4">
                                    <icon-bocalVide
                                        height="150"
                                        width="150"
                                        class="iconBase-blue "
                                    />
                                </div>

                                <h6 class="text-primary text-uppercase">
                                    J'apporte mon bocal où j'en choisis un !
                                </h6>
                                <p class="description text-justify mt-3">

                                </p>
                                <div>
                                    <badge
                                        type="primary"
                                        rounded
                                    >propre</badge>
                                    <badge
                                        type="primary"
                                        rounded
                                    >vide</badge>
                                </div>
                            </card>
                        </div>
                        <div class="col-lg-3">
                            <card
                                class="border-0"
                                hover
                                shadow
                                body-classes="py-5"
                            >
                                <div class="text-center pb-4">
                                    <icon-balance
                                        height="150"
                                        width="150"
                                        class="iconBase-green "
                                    />
                                </div>
                                <h6 class="text-success text-uppercase">
                                    Je le pèse et j'inscris son poids !
                                </h6>
                                <p class="description mt-3">

                                </p>
                                <div>
                                    <badge
                                        type="success"
                                        rounded
                                    >Stylo</badge>
                                    <badge
                                        type="success"
                                        rounded
                                    >Marque</badge>
                                </div>
                            </card>
                        </div>
                        <div class="col-lg-3">
                            <card
                                class="border-0"
                                hover
                                shadow
                                body-classes="py-5"
                            >
                                <div class="text-center pb-4">
                                    <icon-ble
                                        height="150"
                                        width="150"
                                        class="iconBase-orange "
                                    />
                                </div>
                                <h6 class="text-warning text-uppercase">
                                    Je me sers de ce dont j'ai besoin !
                                </h6>
                                <p class="description mt-3">

                                </p>
                                <div>
                                    <badge
                                        type="warning"
                                        rounded
                                    >sans emballage</badge>
                                </div>
                            </card>
                        </div>
                        <div class="col-lg-3">
                            <card
                                class="border-0"
                                hover
                                shadow
                                body-classes="py-5"
                            >
                                <div class="text-center pb-4">
                                    <icon-courses
                                        height="150"
                                        width="150"
                                        class="iconBase-pink "
                                    />
                                </div>
                                <h6 class="text-pink text-uppercase">
                                    Je passe à la caisse.
                                    <br />Et c'est bon !
                                </h6>
                                <p class="description mt-3">

                                </p>
                                <div>
                                    <badge
                                        type="pink"
                                        rounded
                                    >sourire</badge>
                                </div>
                            </card>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import IconBocalVide from '../components/icons/bocalVide.vue'
import IconBalance from '../components/icons/balance.vue'
import IconBle from '../components/icons/ble.vue'
import IconCourses from '../components/icons/courses.vue'
export default {
  name: 'IconBase',
  components: {
    IconBocalVide,
    IconBalance,
    IconBle,
    IconCourses,
  },
}
</script>